import { InvoicesActionTypes } from './invoices.types';

const getInvoicesRequest = () => ({ type: InvoicesActionTypes.GET_INVOICES_REQUEST });
const getInvoicesSuccess = () => ({ type: InvoicesActionTypes.GET_INVOICES_SUCCESS });
const getInvoicesFailure = () => ({ type: InvoicesActionTypes.GET_INVOICES_FAILURE });

const splitPaymentSuccess = () => ({ type: InvoicesActionTypes.SPLIT_PAYMENT_SUCCESS });

const splitPaymentFailure = () => ({ type: InvoicesActionTypes.SPLIT_PAYMENT_FAILURE });

const splitPaymentRequest = (invoiceId, listProductsId, callBackFuction) => ({
  type: InvoicesActionTypes.SPLIT_PAYMENT_REQUEST,
  payload: { invoiceId, listProductsId, callBackFuction },
});

// OLD INVOICE DETAILS ACTIONS
const loadInvoiceDetailsRequest = (invoiceId, callBackFuction) => ({
  type: InvoicesActionTypes.INVOICE_DETAILS_REQUEST,
  payload: { invoiceId, callBackFuction },
});
const loadInvoiceDetailsSuccess = () => ({ type: InvoicesActionTypes.INVOICE_DETAILS_SUCCESS });
const loadInvoiceDetailsFailure = () => ({ type: InvoicesActionTypes.INVOICE_DETAILS_FAILURE });

// NEW INVOICE DETAILS ACTIONS
const requestInvoiceDetails = invoiceId => ({ type: InvoicesActionTypes.GET_INVOICE_DETAILS, payload: invoiceId });
const setInvoiceDetailsLoading = isLoading => ({ type: InvoicesActionTypes.SET_INVOICE_DETAILS_LOADING, payload: isLoading });
const setInvoiceDetails = data => ({ type: InvoicesActionTypes.SET_INVOICE_DETAILS, payload: data });
const invoiceDetailsSuccess = () => ({ type: InvoicesActionTypes.SUCCESS_INVOICE_DETAILS });
const invoiceDetailsFailure = () => ({ type: InvoicesActionTypes.FAILURE_INVOICE_DETAILS });
const resetInvoiceDetailsState = () => ({ type: InvoicesActionTypes.RESET_INVOICE_DETAILS_STATE });

const setInvoiceData = invoiceData => ({
  type: InvoicesActionTypes.SET_INVOICE_DATA,
  payload: invoiceData,
});

const generatePixRequest = ({ invoiceId, callBackFuction }) => ({
  type: InvoicesActionTypes.GENERATE_PIX_REQUEST,
  payload: { invoiceId, callBackFuction },
});

const setPix = ({ qrCode, code, failure = false }) => ({
  type: InvoicesActionTypes.SET_PIX,
  payload: { qrCode, code, failure },
});

const generatePixSuccess = () => ({
  type: InvoicesActionTypes.GENERATE_PIX_SUCCESS,
});

const generatePixFailure = () => ({
  type: InvoicesActionTypes.GENERATE_PIX_FAILURE,
});

const cancelOrderRequest = ({ orderId, reloadData }) => ({
  type: InvoicesActionTypes.CANCEL_ORDER_REQUEST,
  payload: { orderId, reloadData },
});

const cancelOrderSuccess = status => ({
  type: InvoicesActionTypes.CANCEL_ORDER_SUCCESS,
  payload: status,
});

const cancelOrderFailure = status => ({
  type: InvoicesActionTypes.CANCEL_ORDER_FAILURE,
  payload: status,
});

const cancelOrderLoading = loading => ({
  type: InvoicesActionTypes.CANCEL_ORDER_LOADING,
  payload: loading,
});

const getNFSEByInvoiceRequest = invoiceId => ({
  type: InvoicesActionTypes.GET_NFSE_REQUEST,
  payload: { invoiceId },
});

const getNFSEByInvoiceSuccess = () => ({
  type: InvoicesActionTypes.GET_NFSE_SUCCESS,
});

const getNFSEByInvoiceFailure = () => ({
  type: InvoicesActionTypes.GET_NFSE_FAILURE,
});

const setNFSEByInvoice = (listOfNfse = [], currentInvoiceId = null) => ({
  type: InvoicesActionTypes.SET_NFSE,
  payload: {
    listOfNfse,
    currentInvoiceId,
  },
});

const actions = {
  invoices: {
    failure: getInvoicesFailure,
    request: getInvoicesRequest,
    success: getInvoicesSuccess,
    setInvoiceData,

    loadDetails: {
      request: loadInvoiceDetailsRequest,
      success: loadInvoiceDetailsSuccess,
      failure: loadInvoiceDetailsFailure,
    },
    loadDetailsV2: {
      request: requestInvoiceDetails,
      success: invoiceDetailsSuccess,
      failure: invoiceDetailsFailure,
      set: setInvoiceDetails,
      setLoading: setInvoiceDetailsLoading,
      resetState: resetInvoiceDetailsState,
    },
    generatePix: {
      request: generatePixRequest,
      success: generatePixSuccess,
      failure: generatePixFailure,
      setPix,
    },
    splitPayment: {
      request: splitPaymentRequest,
      success: splitPaymentSuccess,
      failure: splitPaymentFailure,
    },
    getNfse: {
      request: getNFSEByInvoiceRequest,
      success: getNFSEByInvoiceSuccess,
      failure: getNFSEByInvoiceFailure,
      set: setNFSEByInvoice,
    },
  },
  cancelOrder: {
    request: cancelOrderRequest,
    success: cancelOrderSuccess,
    failure: cancelOrderFailure,
    loading: cancelOrderLoading,
  },
};

export default actions;
